import React, { useState, useEffect, useRef } from 'react'
import firebase from 'firebase/app'
import 'firebase/auth'
import { Button, TextField } from '@adobe/react-spectrum'
import { loginWithPasswordAndEmail } from '../api/auth-api'

export const AuthProvider = ({ children }) => {
  const [profile, setProfile] = useState()
  const [loading, setLoading] = useState()
  const [fetching, setFetching] = useState(true)
  const emailRef = useRef()
  const passwordRef = useRef()

  useEffect(() => {
    firebase.auth().onAuthStateChanged(async (user) => {
      if (user) {
        setProfile(user)
      }
      setFetching(false)
    })
  }, [])

  const onLoginClicked = async () => {
    const email = emailRef.current.getInputElement().value
    const password = passwordRef.current.getInputElement().value
    if (email !== 'adminpanel@konectsocial.com') {
      window.alert('Invalid email address.')
      return
    }
    if (!password) {
      window.alert("Password can't be empty.")
      return
    }
    setLoading(true)
    await loginWithPasswordAndEmail({ email, password })
    setLoading(false)
  }

  if (fetching) return <div />

  if (!profile) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          padding: 16,
          maxWidth: 400,
        }}
      >
        <TextField ref={emailRef} label="Email:" />
        <TextField ref={passwordRef} label="Password:" />
        <Button
          onPress={onLoginClicked}
          variant="cta"
          marginTop="size-200"
          marginBottom="size-200"
          isDisabled={loading}
        >
          Login
        </Button>
      </div>
    )
  }

  return children
}
